let p = null;
export function loadPayPalSdk(clientId) {
  if (window.paypal) return Promise.resolve(true);
  if (p) return p;
  p = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=USD&intent=capture`;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return p;
}
